import {useTranslation} from "react-i18next";
import {Grid, Skeleton, Typography} from "@mui/material";
import {useClientLocator} from "../../client/ApiClientLocator";
import {useDefaultQuery} from "../../client/useDefaultQuery";
import {StatisticsOverviewDto} from "../../client/statistics/StatisticsApiClient";
import {StatisticsTranslKey} from "./StatisticsTranslKey";
import StatisticsOverviewPanel from "./StatisticsOverviewPanel";

const SKELETON_TILE_COUNT = 4;

export default function StatisticsOverviewContainer() {
    const {statisticsClient} = useClientLocator();
    const {t} = useTranslation();

    const {data, isError} = useDefaultQuery<StatisticsOverviewDto>({
        queryKey: ["statistics", "overview"],
        queryFn: () => statisticsClient.getOverview(),
    });

    if (isError) {
        return <Typography color="error">{t(StatisticsTranslKey.LOAD_ERROR)}</Typography>;
    }

    if (!data) {
        return (
            <div data-testid="statistics-overview-skeleton">
                <Skeleton variant="text" width={200} height={32} sx={{mb: 2}}/>
                <Grid container spacing={2}>
                    {Array.from({length: SKELETON_TILE_COUNT}).map((_, index) => (
                        <Grid item xs={6} md={3} key={index}>
                            <Skeleton variant="rounded" height={96}/>
                        </Grid>
                    ))}
                </Grid>
            </div>
        );
    }

    return <StatisticsOverviewPanel data={data}/>;
}
